import { CMS_API_URL } from 'config';
import { RequestApiDataIfNecessaryPayload } from 'services/api/api.types';
import { AppState, ReduxSelector } from 'store/types';
import {
  dynamicNavbarContentEndpoint,
  dynamicNavbarContentEndpointResourceId,
} from './cmsContent.config';

function selectCmsContent(reduxState: AppState) {
  return reduxState.cmsContent;
}

export function selectNavbarContent(reduxState: AppState) {
  return selectCmsContent(reduxState).navbar;
}

export const selectNavbarContentApiConfig: ReduxSelector<
  RequestApiDataIfNecessaryPayload
> = (reduxState: AppState) => {
  return {
    resourceId: dynamicNavbarContentEndpointResourceId,
    requestConfig: {
      method: 'GET',
      url: dynamicNavbarContentEndpoint,
      baseURL: CMS_API_URL,
    },
    skipDefaultServerErrorHandling: true,
  };
};
